/**
 * PageView Webhook for International Markets
 * 
 * Sends PageView event to n8n on every page load
 */

(function() {
  'use strict';
  
  // Check if helper is available
  if (!window.WebhookHelper || !window.WebhookHelper.isInternationalMarket()) {
    return;
  }
  
  // Get page type from body class or URL
  function getPageType() {
    const bodyClass = document.body.className;
    if (bodyClass.includes('template-product')) return 'product';
    if (bodyClass.includes('template-collection')) return 'collection';
    if (bodyClass.includes('template-cart')) return 'cart';
    if (bodyClass.includes('template-index')) return 'home';
    if (bodyClass.includes('template-page')) return 'page';
    
    const path = window.location.pathname.toLowerCase();
    if (path.includes('/products/')) return 'product';
    if (path.includes('/collections/')) return 'collection';
    if (path.includes('/cart')) return 'cart';
    // Home is the site root or a bare market root (/en-ae/, /de-eu/ ...).
    // Matching the market suffix keeps this correct for any language.
    if (/^\/(?:[a-z]{2}-(?:ae|sa|gb|sg|us|eu|ca|au|my)\/)?$/.test(path)) {
      return 'home';
    }
    
    return 'other';
  }
  
  // Send PageView webhook
  function sendPageViewWebhook() {
    const marketConfig = window.WebhookHelper.getMarketConfig();
    
    window.WebhookHelper.sendWebhook('PageView', {
      custom_data: {
        page_type: getPageType(),
        page_path: window.location.pathname,
        page_title: document.title,
        market: marketConfig.market,
        currency: marketConfig.currency,
        locale: marketConfig.locale
      }
    });
  }
  
  // Fire on page load
  if (document.readyState === 'complete') {
    sendPageViewWebhook();
  } else {
    window.addEventListener('load', sendPageViewWebhook);
  }
  
})();

